<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false,
        isRequired: true,
      },
    },
  };
</script>
<template>
  <div>
    <div v-if="value">
      <v-switch
        :readonly="true"
        inset
        hide-details
        input-value="true"
        color="#3BCA79"
        dense
        class="ma-0"
      ></v-switch>
    </div>
    <div v-else>
      <v-switch
        :readonly="true"
        hide-details
        input-value="true"
        class="rotate ma-0"
        inset
        color="#F56060"
        dense
      ></v-switch>
    </div>
  </div>
</template>
<style lang="scss">
  .rotate {
    .v-input__control {
      .v-input__slot {
        transform: rotate(180deg) !important;
        justify-content: flex-end;
        .v-input--selection-controls__input {
          margin: 0 !important;
        }
      }
    }
  }
</style>
